import { module } from 'angular';
import App from '../../../app';

class SCR1803Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, codeService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		
		this.initWindow(1200, 600);
		this.initText();
		this.initSearch();
		this.initSelect();
		this.initCode();
		
		this.$timeout(() => {
			this.initIntrfcGridOption();
			this.initGetEffectsList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMetaInfo'));
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initCode(){
		this.tranDscdList = this.codeService.getCodesByCdIdFromMem('TRAN_DSCD');
		this.syncDscdList = this.codeService.getCodesByCdIdFromMem('CHL_DSCD');
	}
	
	initIntrfcGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill', vscrollBar: true}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "intrfcId"}, {fieldName: "intrfcNm"}, {fieldName: "intrfcType"}, {fieldName: "msgLayoutId"}, {fieldName: "lv3Cd"},
    		 {
             	fieldName: "chlDscd",
             	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
             		return this.codeService.getCodeValNm('CHL_DSCD', values[fieldNames.indexOf('chlDscd')]);
         		}
    		 }, 
             {
         		fieldName: "trxDscd",
         		calculateCallback: (dataRow, fieldName, fieldNames, values) => {
             		return this.codeService.getCodeValNm('TRAN_DSCD', values[fieldNames.indexOf('trxDscd')]);
         		}
             }, 
    		 , {fieldName: "revision"}, {fieldName: "msgDataVal"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 20, styles: { textAlignment: 'center' } },
			{ name: "intrfcId", fieldName: "intrfcId", header : { text: this.text.intrfcId }, width: 90, styles: { textAlignment: 'center' } },
			{ name: "intrfcNm", fieldName: "intrfcNm", header : { text: this.text.intrfcNm }, width: 90, styles: { textWrap: 'ellipse' } },
			{ name: "intrfcType", fieldName: "intrfcType", header : { text: this.text.dataTypeNm }, width: 40, styles: { textAlignment: 'center' } },
			{ name: "msgLayoutId", fieldName: "msgLayoutId", header : { text: this.text.msgLayoutId }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "lv3Cd", fieldName: "lv3Cd", header : { text: this.text.appCode }, width: 70, styles: { textAlignment: 'center' } },
			{ name: "chlDscd", fieldName: "chlDscd", header : { text: this.text.chlDscd }, width: 40, styles: { textAlignment: 'center' } },
			{ name: "trxDscd", fieldName: "trxDscd", header : { text: this.text.trxDscd }, width: 40, styles: { textAlignment: 'center' } },
			{ name: "revision", fieldName: "revision", header : { text: this.text.revision }, width: 50, styles: { textAlignment: 'center' } },
			{ name: "msgDataVal", fieldName: "msgDataVal", header : { text: this.text.msgDataVal }, width: 50, styles: { textWrap: 'ellipse' } },
			
			{ 
				name: "buttonColumn", fieldName: "buttonColumn", button: 'image', buttonVisibility: 'always', header : { text: this.text.showDetail }, width: 40, cursor: 'pointer',
				renderer: {
					type: 'imageButtons',
					alignment: 'center',
					images: [{
						name: 'more',
						up: './assets/images/grid/detail.png',
						width: 20
					}]
				}
			}
		]);
		
		this.gridView.onImageButtonClicked = (grid, itemIndex, column, buttonIndx, name) => {
			this.openTab(grid.getValues(itemIndex));
		};
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.openTab(grid.getValues(cell.itemIndex));
		};
	}
	
	openTab(record){
		let state;
		
		if(record.intrfcType === 'MCI') {
			state = 'main.manageMciInterface';
		}else if(record.intrfcType === 'EAI_I') {
			state = 'main.manageEaiInterface';
		}else if(record.intrfcType === 'FEP') {
			state = 'main.manageFepInterface';
		}else if(record.intrfcType === 'EAI_E') {
			state = 'main.manageEaiInterface2';
		}else if(record.intrfcType === 'CC') {
			state = 'main.manageCcInterface';
		}
		
		this.utilService.openTab(this.$scope, {
			state: state
		}, {
			data: {
				intrfcId: record.intrfcId,
				msgLayoutId: record.msgLayoutId,
				delYN: 'N'
			}
		}, 'main.manageMetaInfo');
	}
	
	initGetEffectsList(){
		const data = this.data;
		
		if(_.isEmpty(data)){
			this.getEffectList = this.getMetaEffectedInterfaceList;
		} else {
			if(this.data.metaEngNm) this.getEffectList = this.getMetaEffectedInterfaceList;
			else if(data.msgLayoutId) this.getEffectList = this.getMsglayoutEffectedInterfaceList;
			else this.getEffectList = this.getMetaEffectedInterfaceList;
		}
		
		this.getEffectList();
	}
	
	getMetaEffectedInterfaceList(){
		let url = `/metas/effectList?metaEngNm=${this.data.metaEngNm}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			this.dataProvider.setRows(data);
		});
	}
	
	getMsglayoutEffectedInterfaceList(){
		let encodedId = encodeURIComponent(this.data.msgLayoutId);
		let url = `/msglayouts/${encodedId}/effects?`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			this.dataProvider.setRows(data);
		});
	}
	
	resetSearch(){
		this.searchParam = { };
		this.getMetaEffectedInterfaceList();
	}
	
	search(){
		this.getMetaEffectedInterfaceList();
	}
	
	blur($event){
		$event.target.blur();
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	searchApplicationCodes(){
		this.popupService.openModal('SCR1402', { limitLvCd: 0 })
						 .then((codes) => {
							this.searchParam.lv1Cd = "";
							this.searchParam.lv2Cd = "";
							this.searchParam.lv3Cd = "";
							 
							codes.map((code, index) =>{
								this.searchParam[`lv${index +1}Cd`] = code.appCd;
							});
						 })
						 .catch(()=>{});
	}
	
	getLvCd(lvCds) {
		let lvCd = '';
		
		if(lvCds) {
			if(lvCds.lv1Cd) {
				lvCd = lvCds.lv1Cd;
			}
			
			if(lvCds.lv2Cd) {
				lvCd += '/' + lvCds.lv2Cd;
			}
			
			if(lvCds.lv3Cd) {
				lvCd += '/' + lvCds.lv3Cd;
			}	
		}
		
		return lvCd;
	}
	
	xlsExport() {
		let url = `/metas/effectList/export?metaEngNm=${this.data.metaEngNm}`;
		this.popupService.showLoadingBar(this.$scope);
		this.httpService.downloadFile(url, this.searchParam, 'get').then(res => {
			if(res.isError){
				this.popupService.detailAlert(this.$scope, res.data.message, res.data.stackTrace);
			}else{
				var header = decodeURIComponent(res.headers('Content-Disposition'));
				var fileName = header.split("=")[1].replace(/\"/gi,'');
				console.log(fileName);
				
				var blob = new Blob([res.data], {type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
				this.utilService.saveFile(blob, fileName);
			}
		})
		.finally(() => {
			this.popupService.closeLoadingBar();
		});
	}
}

module(App.name).controller('SCR1803Controller', SCR1803Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1803/SCR1803.controller.js